/** Root settings document versioned in localStorage (browser only). */
export const APP_SETTINGS_STORAGE_KEY = "ead-expui.settings.v1";

export type SettingsPageId = "ai-models" | "credentials" | "advanced";

export type AiModelsSettings = {
  /** Main Hermes `model:` (e.g. deepseek/deepseek-chat). */
  reasoningModel: string;
  /** Vision auxiliary: OpenAI-compatible image understanding. */
  visionModel: string;
  /** e.g. https://api.openai.com/v1 — routed as Hermes auxiliary.vision custom endpoint. */
  visionOpenAIBaseUrl: string;
};

export type AppSettingsV1 = {
  version: 1;
  aiModels: AiModelsSettings;
};
